import React, {Component} from 'react';
import {Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import JunkSizeMailService from '../../services/JunkSizeMailService';
import Loader from 'react-loader-spinner';
import CardFlippableBag from "../../common/CardFlippableBag";

class BagJunk extends Component {
    constructor(props) {
        super(props);

        this.localState = this.props.localState;

        this.JunkSizeMailService = new JunkSizeMailService();

        this.handleSelectJunk = this.handleSelectJunk.bind(this);
        this.togglePhotoModal = this.togglePhotoModal.bind(this);
        this.handleInputFileClick = this.handleInputFileClick.bind(this);
        this.handleSelectedFileNames = this.handleSelectedFileNames.bind(this);
        this.submitFormData = this.submitFormData.bind(this);
        this.handleFilesUpload = this.handleFilesUpload.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);

        this.state = {
            photoModal: false,
            confirmCheckbox: false,
            fileNames: [],
            filesForUpload: [],
            first_name: '',
            last_name: '',
            email: '',
            filesError: false,
            filesErrorMessage: '',
            mailSuccess: false,
            mailSuccessMessage: '',
            mailError: false,
            mailErrorMessage: '',
            errorResponse: null,
            loading: false,
            disabled: false,
            quantityValidation: ""
        };

        // window.ga('send', 'event', 'wizard', 'wizard', 'Junk select')
        ga('set', 'page', '/wizard/man-and-van/step-1/junk-select');
        ga('send', 'pageview')
    }


    togglePhotoModal() {
        this.setState({
            first_name: '',
            last_name: '',
            email: '',
            fileNames: [],
            errorResponse: null,
            photoModal: !this.state.photoModal
        }, () => {
            this.inputFile.value = null
        });
    }

    isQuantitySelected(sizes) {
        //  Check if user has selected quantity of bags
        let qty = 0;
        sizes.map(size => {
            qty += size.quantity
        });

        return qty > 0;
    }

    handleSelectJunk(size) {
        if (this.isQuantitySelected(size)) {
            this.localState.size = size;
            this.props.setValidity(true);
            this.props.globalStateChange(this.localState);
            this.props.updatePrice();
            this.props.nextStep(size);
            this.setState({quantityValidation: ""})
        } else {
            this.props.setValidity(false);
            this.setState({quantityValidation: "Please select quantity first."})
        }

    }

    handleSelectedFileNames() {
        let files = [];

        this.setState({
            filesError: false,
            filesErrorMessage: '',
            filesForUpload: []
        }, () => {
            if (this.inputFile.files.length > 3) {
                return this.setState({
                    filesError: true,
                    filesErrorMessage: 'You cannot upload more than 3 images'
                })
            }

            for (let i = 0; i < this.inputFile.files.length; i++) {
                files = [...files, `${this.inputFile.files[i].name} (${Math.round(this.inputFile.files[i].size / 1000)}kb)`];
            }
            this.setState({
                fileNames: files,
                filesForUpload: Array.from(this.inputFile.files)
            });
        });
    }

    handleInputChange(event) {
        // event.preventDefault();
        const target = event.target;
        const value = target.name === 'confirmCheckbox' ? target.checked : target.value;
        const name = target.name;
        console.log(value, name)

        this.setState({
            [name]: value
        });
    }

    submitFormData() {
        const formData = new FormData();

        formData.append('first_name', this.state.first_name);
        formData.append('last_name', this.state.last_name);
        formData.append('email', this.state.email);
        this.state.filesForUpload.map((file, i) => {
            formData.append(`images[${i}]`, file);
        });

        this.setState({
            errorResponse: null,
            loading: true
        }, () => {
            this.JunkSizeMailService.sendJunkSizeEmail(formData)
                .then(res => {
                    if (res.status == 200) {
                        this.setState({
                            loading: false,
                            disabled: true,
                            mailSuccess: true,
                            mailSuccessMessage: res.data.message,
                        }, () => {
                            sessionStorage.clear();
                            setTimeout(function () {
                                window.location.href = '/mail-success'
                            }, 2000)
                        });
                    } else {
                        this.setState({
                            loading: false,
                            errorResponse: 'Unknown error occurred, please contact support'
                        })
                    }
                }, err => console.log(err))
                .catch(err => {
                    this.setState({
                        loading: false,
                        errorResponse: err.response.data.errors
                    })
                })
        })
    }

    handleInputFileClick() {
        this.inputFile.click();
    }

    handleFilesUpload(filesUpload) {
        let files = Array.from(filesUpload);
        this.setState({
            filesForUpload: files
        });
    }

    render() {
        const btnDisabled = this.state.confirmCheckbox ? 'disabled' : '';
        return (
            <section id="sizes">
                <div className="container pb-5">
                    <div className="row pb-3 justify-content-center">
                        <h2 className="wizard-heading pt-sm-0 pt-5">
                            {this.props.headerTitle ? this.props.headerTitle : 'Choose a collection size'}
                        </h2>
                    </div>
                    {/*<div className="row justify-content-center text-center" style={{ paddingLeft: '15px', paddingRight: '15px' }}>*/}
                    {/*        <div className="col-md-10">*/}
                    {/*            <div className="alert alert-dark"><p className='pb-0 mb-0'>Not sure about the collection size you need? Send us a <span className='prohibited-items' onClick={this.togglePhotoModal}><u>photo</u>.</span></p></div>*/}
                    {/*        </div>*/}
                    {/*</div>*/}
                    <div className="row">
                        {/* This column is used for centering/offseting cards*/}
                        <div className="col-md-2"/>
                        {this.props.sizes.map((size, index) => {
                            return (
                                <CardFlippableBag
                                    buyBags={this.props.buyBags}
                                    key={index}
                                    size={size}
                                    localState={this.props.localState}
                                    openModal={this.togglePhotoModal}
                                    handleSelectJunk={() => this.handleSelectJunk(size)}
                                    increment={this.props.increment}
                                    decrement={this.props.decrement}
                                />
                            )
                        })}
                    </div>
                    {this.props.buyBags &&
                    <>
                        <div className="row justify-content-center pt-5">
                            <div className="col-md-10">
                                <div className="alert alert-dark">
                                    <p style={{marginBottom: '0'}}>
                                        {`Please note: the prices shown here are for the Waste Bags themselves, not for collection. 
                                        The Waste Bag is yours to keep and reuse. Collection of your filled Waste Bag costs 
                                        £${this.props.sizes[0].price / 100} for the 2 cubic yard size and £${this.props.sizes[1].price / 100} 
                                        for the 4 cubic yard version. You don’t need to 
                                        book and pay for a collection until your Waste Bag is filled. On collection, we will empty 
                                        the Waste Bag into our
                                        van and leave it for you to use again.`}
                                        <br/><br/>We aim to deliver your waste bag within 2 – 3 working days.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10">
                                <div className="alert alert-dark">
                                    <input
                                        name="confirmCheckbox"
                                        type="checkbox"
                                        checked={this.state.confirmCheckbox}
                                        onChange={this.handleInputChange}/>
                                    <p className="d-inline pl-2">I acknowledge that the above costs relate to the waste bags and that the collection of the bags incurs additional costs.</p>
                                </div>
                            </div>
                        </div>
                    </>
                    }
                    {this.props.buyBags &&
                    <div className="mt-4 text-center">
                        <button className="btn btn-round py-3 btn-cw btn-yellow" disabled={!this.state.confirmCheckbox}
                                onClick={(e) => this.handleSelectJunk(this.props.sizes)}>Next
                        </button>
                    </div>
                    }
                    {!this.props.buyBags &&
                    <div className="mt-5 text-center">
                        <button className="btn btn-round py-3 btn-cw btn-yellow"
                                onClick={(e) => this.handleSelectJunk(this.props.sizes)}>Next
                        </button>
                    </div>
                    }
                    <div className="mt-3 text-center">
                        <p>{this.state.quantityValidation}</p>
                    </div>
                    <div className="row justify-content-center mt-5">
                        <div className="col-md-10">
                            <div className="alert alert-dark">
                                <p style={{marginBottom: '0'}}>All prices quoted are in GBP and include VAT at the current rate.</p>
                            </div>
                        </div>
                    </div>
                </div>

                <Modal isOpen={this.state.photoModal} toggle={this.togglePhotoModal} className={'modal-lg'}>
                    <ModalHeader toggle={this.togglePhotoModal}>Let us help</ModalHeader>
                    <ModalBody>
                        <div className="row justify-content-center py-1">
                            <div className="col-md-10 text-center">
                                <img src='/assets/img/photo.svg' alt="size" width='200'/>
                            </div>
                        </div>
                        <div className="row justify-content-center pt-2">
                            <div className="col-md-10">
                                <p>Send us up to 3 photos of the waste you need collecting and we'll be delighted to recommend a suitable collection size. <br/>
                                    We aim to respond within 2 hours (Mon - Fri, 09:00 - 17:00 excluding bank holidays.)</p>
                            </div>
                        </div>
                        {this.state.mailSuccess &&
                        <div className="row justify-content-center p-3">
                            <div className="col-md-10 justify-content-center alert alert-success">
                                <p className='mb-0'>{this.state.mailSuccessMessage}</p>
                            </div>
                        </div>
                        }
                        {this.state.mailError &&
                        <div className="row justify-content-center pt-3">
                            <div className="col-md-10 justify-content-center alert alert-success">
                                <p className='mb-0'>{this.state.mailErrorMessage}</p>
                            </div>
                        </div>
                        }
                        <input type="file" name='images' multiple={true} hidden={true} ref={(section) => {
                            this.inputFile = section;
                        }} onChange={this.handleSelectedFileNames}/>
                        <div className="row justify-content-center text-center pt-3">
                            <div className="col-md-3 col-sm-12 col" onClick={this.handleInputFileClick}>
                                <div className='upload-modal'
                                     style={{border: '1px solid grey', padding: '10px', borderRadius: '7px'}}>
                                    <div><i className='fa fa-plus-square-o fa-2x'> </i></div>
                                    <p style={{marginBottom: '0'}}>add images</p>
                                </div>
                            </div>
                        </div>
                        {this.state.filesError &&
                        <div className="row justify-content-center text-center mt-3">
                            <div className="col-md-10 justify-content-center alert alert-danger">
                                <p>{this.state.filesErrorMessage}</p>
                            </div>
                        </div>
                        }
                        {this.state.fileNames.length > 0 &&
                        <div className="row justify-content-center text-center mt-3 px-3">
                            <div className="col-md-10 justify-content-center alert alert-dark mb-0">
                                {this.state.fileNames.map((file, index) => {
                                    return (
                                        <p className='file-names' key={index + 1}>{index + 1}. {file}</p>
                                    )
                                })}
                            </div>
                            {(this.state.errorResponse && (this.state.errorResponse["images.0"] || this.state.errorResponse["images.1"] || this.state.errorResponse["images.2"])) &&
                            <small className='text-danger pt-1'>Uploaded files need to be images.</small>
                            }
                        </div>
                        }

                        {(this.state.errorResponse && this.state.errorResponse.images) &&
                        <div className='row text-center justify-content-center pt-1'>
                            <small className='text-danger'>{this.state.errorResponse.images[0]}</small>
                        </div>
                        }
                        <div className="row justify-content-center pt-3">
                            <div className="col-md-10 form-group">
                                <label>First Name:</label>
                                <input type="text" name='first_name' className="form-control" placeholder='First name...' onChange={(e) => this.handleInputChange(e)}/>
                                {(this.state.errorResponse && this.state.errorResponse.first_name) &&
                                <div><small className='text-danger'>{this.state.errorResponse.email[0]}</small></div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 form-group">
                                <label>Last Name:</label>
                                <input type="text" name='last_name' className="form-control" placeholder='Last name...' onChange={(e) => this.handleInputChange(e)}/>
                                {(this.state.errorResponse && this.state.errorResponse.last_name) &&
                                <div><small className='text-danger'>{this.state.errorResponse.last_name[0]}</small></div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 form-group">
                                <label>Email:</label>
                                <input type="text" name='email' className="form-control" placeholder='Your email...' onChange={(e) => this.handleInputChange(e)}/>
                                {(this.state.errorResponse && this.state.errorResponse.email) &&
                                <div><small className='text-danger'>{this.state.errorResponse.email[0]}</small></div>
                                }
                            </div>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-md-10 form-group text-right">
                                <button className='btn btn-round py-3 btn-cw btn-yellow'
                                        onClick={this.submitFormData} disabled={(this.state.first_name == '' || this.state.last_name == '' || this.state.email == '' || !this.state.fileNames) || this.state.disabled}>
                                    <div className='d-flex flex-row justify-content-center'>
                                        {this.state.loading &&
                                        <div style={{
                                            display: 'inline-block',
                                            paddingRight: '5px',
                                        }}>
                                            <Loader type="Oval" color="#fff" height={15} width={15}/>
                                        </div>
                                        }
                                        <div>Submit</div>
                                    </div>
                                </button>
                            </div>
                        </div>
                    </ModalBody>
                </Modal>
            </section>
        );
    }
}


export default BagJunk;

